import SCHEDULE_EVENTS from '@webapp-next/modules/schedule/events';
import tryEmit from './lib/try-emit';

function refresh() {
  tryEmit(SCHEDULE_EVENTS.REFRESH);
}

function updateEmployee(id) {
  tryEmit(SCHEDULE_EVENTS.UPDATE_EMPLOYEES, {id: id});
}

function updateEmployees() {
  tryEmit(SCHEDULE_EVENTS.UPDATE_EMPLOYEES);
}

async function updateShifts(shiftIds) {
  tryEmit(SCHEDULE_EVENTS.REFRESH_SHIFT, {ids: shiftIds})
  tryEmit(SCHEDULE_EVENTS.ADJUST_SHIFTS);
}

const schedule = { refresh, updateShifts, updateEmployee, updateEmployees };

export default schedule;
